import { Timestamp } from "firebase/firestore";

export class AuditData {
    
    createdAt: Timestamp | null = null;
    createdBy: string | null = null;
    updatedAt: Timestamp | null = null;
    updatedBy: string | null = null;
    
    constructor(data?: Partial<AuditData>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}